module.exports = __webpack_public_path__ + "img/Scalable.8759d8be.svg";